import React from 'react';
import Layout from '../components/layout/Layout';
import Configuraciones from '../components/configuraciones/Configuraciones';

export const ConfiguracionPage = () => {
    return ( <Layout children={<Configuraciones />} /> )
}